import React from "react";
import styles from "./Style.module.css";
import DashboardSnackbar from "../../../components/Snackbar.component";
import logoImage from "../../../assets/CRMAssets/psconnect_login_logo@2x.png";

import { Typography, IconButton, InputAdornment } from "@mui/material";
import {
  ArrowBack,
  Visibility,
  VisibilityOff,
  LockOutlined,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";

import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton";
import useResetPasswordHook from "./ResetPassword.hook";

function ResetPassword() {
  const theme = useTheme();

  const {
    handleSubmit,
    onBlurHandler,
    changeTextData,
    form,
    errorData,
    togglePasswordVisibility,
    showPassword,
    toggleConfirmPasswordVisibility,
    showConfirmPassword,
    isSubmitting,
  } = useResetPasswordHook();

  return (
    <div className="login">
      <div className={styles.overlay}></div>
      <div className={styles.mainLoginView}></div>

      <div className={styles.container}>
        <div className={styles.loginFlex2}>
          <div className={styles.signContainer}>

            {/* Back */}
            <div className={styles.backContainer}>
              <Link
                to="/login"
                className={styles.backLink}
                style={{
                  color: theme.palette.primary.main,
                }}
              >
                <ArrowBack sx={{ fontSize: "18px", marginRight: "6px" }} />
                Back to Login
              </Link>
            </div>

            {/* Logo */}
            <div className={styles.logoImageData}>
              <img
                src={logoImage}
                alt="logo"
                className={styles.logo}
              />
            </div>

            {/* Heading */}
            <div className={styles.loginHeaderText}>
              <h3>Set New Password</h3>

              <p>
                Choose a strong password for your account.
              </p>
            </div>

            {/* Form */}
            <div className={styles.formContainer}>

              {/* New Password */}
              <div className={styles.formGroup}>
                <Typography className={styles.fieldLabel}>
                  New Password
                  <span className={styles.required}> *</span>
                </Typography>

                <CustomTextField
                  type={showPassword ? "text" : "password"}
                  value={form.password}
                  isError={errorData.password}
                  errorText={errorData.password}
                  placeholder="Min. 8 characters"
                  onTextChange={(text) => changeTextData(text, "password")}
                  onBlur={() => onBlurHandler("password")}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={togglePasswordVisibility}
                          edge="end"
                          sx={{ color: "#7b8aa0" }}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </div>

              {/* Confirm Password */}
              <div className={styles.formGroup}>
                <Typography className={styles.fieldLabel}>
                  Confirm Password
                  <span className={styles.required}> *</span>
                </Typography>

                <CustomTextField
                  type={showConfirmPassword ? "text" : "password"}
                  value={form.confirm_password}
                  isError={errorData.confirm_password}
                  errorText={errorData.confirm_password}
                  placeholder="Re-enter your password"
                  onTextChange={(text) =>
                    changeTextData(text, "confirm_password")
                  }
                  onBlur={() => onBlurHandler("confirm_password")}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle confirm-password visibility"
                          onClick={toggleConfirmPasswordVisibility}
                          edge="end"
                          sx={{ color: "#7b8aa0" }}
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </div>

              {/* Button */}
              <div className={styles.logFlex}>
                <PrimaryButton
                  fullWidth
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  className={styles.button}
                >
                  RESET PASSWORD <LockOutlined sx={{ marginLeft: "8px", fontSize: "20px" }} />
                </PrimaryButton>
              </div>

            </div>
          </div>
        </div>

        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default ResetPassword;
